import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmailVerificationService {
  constructor(private http: HttpClient) {
    // console.log('EmailVerificationService initialized');
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
  }

  generateOtp(email: string, language: 'en' | 'zh'): Observable<any> {
    const payload = {
      email,
      language, // Include language preference in the payload
    };
    return this.http.post(`${environment.otpBaseUrl}/generate-OTP`, payload);
  }

  validateOtp(email: string, otp: string): Observable<any> {
    const payload = { email, otp };
    return this.http.post(`${environment.otpBaseUrl}/validate-OTP`, payload);
  }
}
